import { render } from "./RecommendedProviders.vue?vue&type=template&id=b57ff3e8&scoped=true"
import script from "./RecommendedProviders.vue?vue&type=script&lang=js"
export * from "./RecommendedProviders.vue?vue&type=script&lang=js"

import "./RecommendedProviders.vue?vue&type=style&index=0&id=b57ff3e8&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b57ff3e8"]])

export default __exports__